import Theme from 'core/themes/model'

const checkboxStyles = (theme: Theme) => ({
  checkboxWrapper: {
    display: 'inline-block',
  },
  checkbox: {
    '&:hover': {
      background: 'transparent',
    },
    '& .checkbox-frame:hover': {
      background: theme.components.checkbox.hoverBackground,
    },
  },
})

export default checkboxStyles
